import { Component, Vue } from 'vue-property-decorator'
import fetch from '@/helpers/fetch'
import { Auditoria } from '@/types/auditoria'
import TypeableDatePortal from '@/components/edit/TypeableDatePortal/index.vue'
import vSelect from 'vue-select'
import { library } from '@fortawesome/fontawesome-svg-core'
import { faArrowUpFromBracket } from '@fortawesome/free-solid-svg-icons'

library.add(faArrowUpFromBracket)

Vue.component('v-select', vSelect)

@Component({
	components: { TypeableDatePortal },
})
export default class ModalArquivados extends Vue {
	auditorias: Auditoria[] = []
	loading = false
	searched = false

	filters = {
		group_id: null as number | null,
		request_date_start: '',
		request_date_end: '',
	}

	groups: any[] = []
	loadingGroups = false

	async onShow() {
		this.auditorias = []
		this.searched = false
		this.filters = { group_id: null, request_date_start: '', request_date_end: '' }

		const loadGroups = this.groups.length
			? Promise.resolve()
			: (async () => {
				this.loadingGroups = true
				try {
					const res = await fetch.get('/api/groups')
					this.groups = res.data || []
				} finally {
					this.loadingGroups = false
				}
			})()

		await Promise.all([loadGroups, this.search()])
	}

	async search() {
		this.loading = true
		try {
			const params = new URLSearchParams({ status: 'Arquivado' })
			if (this.filters.group_id) params.append('group_id', String(this.filters.group_id))
			if (this.filters.request_date_start) params.append('request_date_start', this.filters.request_date_start)
			if (this.filters.request_date_end) params.append('request_date_end', this.filters.request_date_end)

			const res = await fetch.get(`/api/audits?${params.toString()}`)
			this.auditorias = res.data || []
			this.searched = true
		} finally {
			this.loading = false
		}
	}

	formatDate(dateStr: string | null): string {
		if (!dateStr) return '—'
		const [year, month, day] = dateStr.split('-')
		if (!year || !month || !day) return dateStr
		return `${day}/${month}/${year}`
	}

	labelSource(val: string): string {
		return val === 'carta' ? 'Carta' : val === 'relatório' ? 'Relatório' : val || '—'
	}

	labelResponseType(val: string): string {
		return val === 'email' ? 'E-mail' : val === 'portal-terceiro' ? 'Portal terceiro' : val === 'correio' ? 'Correio' : val || '—'
	}

	unarchiving: Record<number | string, boolean> = {}
	didUnarchive = false

	async unarchive(auditoria: Auditoria) {
		Vue.set(this.unarchiving, auditoria.id, true)
		try {
			await fetch.post(`/api/audits/${auditoria.id}/unarchive`, {})
			this.auditorias = this.auditorias.filter(a => a.id !== auditoria.id)
			this.didUnarchive = true
		} finally {
			Vue.set(this.unarchiving, auditoria.id, false)
		}
	}

	onHide() {
		if (this.didUnarchive) {
			this.$emit('unarchived')
			this.didUnarchive = false
		}
	}
}
